<template>
  <div id="attestation" class="page-layout__inner">

    <div :class="'page-layout__filter' + (filterSettings.visible ? '' : ' w-auto')">
      <section :class="'section  section--shadow-0  section--p-0' + (filterSettings.visible ? ' h-100' : '')">
        <button @click="filterSettings.visible = true"
                :class="'section__filter-btn' + (filterSettings.visible ? ' section__filter-btn--hidden' : '')">
          <svg class="section__filter-icon">
            <use xlink:href="#icon__filter"></use>
          </svg>
        </button>
        <div :class="'section__filter' + (filterSettings.visible ? '' : ' section__filter--hidden')">
          <div class="section__header">
            <h3 class="section__title">
              <svg class="section__filter-icon">
                <use xlink:href="#icon__filter"></use>
              </svg>
              {{ getTranslation('filter') }}
            </h3>

            <div class="section__controls">
              <div class="section__controls-group">
                <a @click="filterSettings.visible = false" class="btn  btn--xs  btn--control  js-filterHider"
                   href="javascript:void(0)">{{ getTranslation('hide') }}</a>
                <a class="btn  btn--xs  btn--control" href="javascript:void(0)"
                   @click="resetFilter()">{{ getTranslation('reset') }}</a>
              </div>
            </div>
          </div>

          <div class="section__body">
            <div class="form__group">
              <label class="form__label  form__label--block">{{ getTranslation('searchByName') }}</label>
              <div class="field-advanced">
                <form method="post" @submit.prevent="fetchNrkResources">
                  <div class="field-advanced__inner">
                    <div class="field-advanced__field-wrap">
                      <input v-model="filterForm.query"
                             class="field  field--full-width  field--bg-grey  js-borderOnFocus" type="text"
                             :placeholder="getTranslation('searchByName')">
                    </div>

                    <div class="field-advanced__right">
                      <button class="btn  btn--square  btn--main">
                        <svg class="btn__icon">
                          <use xlink:href="#icon__search"></use>
                        </svg>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="form__group">
              <label class="form__label  form__label--block">{{ getTranslation('resource') }}</label>
              <v-select
                  v-if="showOptions"
                  :placeholder="getTranslation('selectFromList')"
                  label="title"
                  :reduce="option=>option.id"
                  :options="formOptions.resources"
                  v-model="filterForm.resourceId"
              />
            </div>
            <div class="form__group">
              <label class="form__label  form__label--block">{{ getTranslation('registerCategories') }}</label>
              <v-select
                  v-if="showOptions"
                  :placeholder="getTranslation('selectFromList')"
                  label="title"
                  :reduce="option=>option.id"
                  :options="formOptions.registerCategories"
                  v-model="filterForm.registerCategoryId"
                  @input="fetchItems"
              />
            </div>

            <div class="form__group">
              <label class="form__label  form__label--block">{{ getTranslation('postScope') }}</label>
              <label v-for="stat in formOptions.postScopes" class="checkbox  checkbox--inline">
                <input class="checkbox__input" type="checkbox" v-model="filterForm.postScope" :value="stat.id">
                <span class="checkbox__indicator  checkbox__indicator--inline"></span>
                <span class="checkbox__label">{{ stat.title }}</span>
              </label>
            </div>

            <div class="form__group">
              <label class="form__label  form__label--block">{{ getTranslation('status') }}</label>
              <label v-for="stat in formOptions.statuses" class="checkbox  checkbox--inline">
                <input class="checkbox__input" type="checkbox" v-model="filterForm.status" :value="stat.id">
                <span class="checkbox__indicator  checkbox__indicator--inline"></span>
                <span class="checkbox__label">{{ stat.title }}</span>
              </label>
            </div>

          </div>

        </div>
      </section>
    </div>

    <div class="page-layout__content">
      <p class="page-layout__descr  text">{{ getTranslation('foundWithQuantity', items.length) }}</p>

      <div class="page-layout__group">

        <section class="section">

          <div class="section__body">
            <table class="table  table-zebra  table--noborder">
              <thead class="table__head">
              <tr class="table__row">
                <th class="table__cell  table__hcell" style="width: 5%;">#</th>
                <th class="table__cell  table__hcell" style="width: 15%;">{{ getTranslation('title') }}</th>
                <th class="t  able__cell  table__hcell" style="width: 25%;">{{ getTranslation('resource') }}</th>
                <th class="table__cell  table__hcell" style="width: 12%;">{{ getTranslation('postScope') }}</th>
                <th class="table__cell  table__hcell" style="width: 5%;">{{ getTranslation('status') }}</th>
                <th class="table__cell  table__hcell" style="width: 0.2%;"></th>
              </tr>
              </thead>
              <tbody class="table__body">
              <tr v-for="item in items" v-bind:key="item.id" class="table__row">
                <td class="table__cell font-weight-bold">
                  {{ item.id }}
                </td>
                <td class="table__cell">
                  <router-link :to="{name:'api.nrk.resource.get',params:{id:item.id,type:'attestation'}}"> {{
                      item.title
                    }}
                  </router-link>
                </td>
                <td class="table__cell">
                  {{ item.resourceTitle }}
                </td>
                <td class="table__cell">
                  {{ getTranslation(item.postScopeText) }}
                </td>
                <td class="table__cell">
                  {{ item.statusText }}
                </td>
                <td class="table__cell">
                  <ActionsComponent
                      :has-edit="hasPermission('api.attestation.resource.update')"
                      v-on:edit="editResource(item)"
                      :has-delete="false"
                  />
                </td>
              </tr>
              </tbody>
            </table>
          </div>

        </section>

      </div>
      <div class="page-layout__pagination" v-if="pagination.total && pagination.lastPage > 1">
        <pagination :pagination="pagination" @change="()=>{fetchItems();this.$scrollTo('#attestation');}"
                    v-model="filterForm.page"></pagination>
      </div>

    </div>

    <modal
        v-model="showModal"
        :modal-title="edit ? getTranslation('edit') : getTranslation('add')"
        :ok-button-label="getTranslation('save')"
        :cancel-button-label="getTranslation('cancel')"
        @ok-button-click="saveResource"
        @cancelButtonClick="resetModal"
        @input="resetModal"
    >
      <div class="form__group">

        <div class="form__group">
          <label class="form__label  form__label--block" for="title">{{ getTranslation('title') }} <span
              class="required">*</span> </label>
          <input v-model.trim="form.title" class="field  field--full-width"
                 :class="{ 'field--error': $v.form.title.$error }" type="text" id="title">
          <div v-if="$v.form.title.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
        </div>

        <div class="form__group">
          <label class="form__label  form__label--block" for="titleKy">{{ getTranslation('titleKy') }} <span
              class="required">*</span> </label>
          <input v-model.trim="form.titleKy" class="field  field--full-width"
                 :class="{ 'field--error': $v.form.titleKy.$error }" type="text" id="titleKy">
          <div v-if="$v.form.titleKy.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
        </div>

        <div class="form__group">
          <label class="form__label  form__label--block">{{ getTranslation('resource') }}<span class="required">*</span></label>
          <v-select
              v-if="showOptions && !positionAttestation"
              :placeholder="getTranslation('selectFromList')"
              label="title"
              :reduce="option=>option.id"
              :options="formOptions.resources"
              :class="{'field--error':$v.form.resourceId.$error}"
              v-model="form.resourceId"
          />
          <v-select
              v-if="showOptions && positionAttestation"
              :placeholder="getTranslation('selectFromList')"
              label="title"
              :reduce="option=>option.id"
              :options="formOptions.registerCategories"
              :class="{'field--error':$v.form.resourceId.$error}"
              v-model="form.resourceId"
          />
        </div>
        <div v-if="$v.form.resourceId.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
      </div>

      <div class="form__group">
        <label class="form__label  form__label--block">{{ getTranslation('postScope') }}</label>
        <v-select
            v-if="showOptions && !positionAttestation"
            :placeholder="getTranslation('selectFromList')"
            label="title"
            :reduce="option=>option.id"
            :options="formOptions.postScopes"
            v-model="form.postScope"
        />
      </div>
      <div class="checkbox-group  form__group">
        <label class="checkbox">
          <input class="checkbox__input" v-model="form.status" type="checkbox"/>
          <span class="checkbox__indicator  checkbox__indicator--inline"/>
          <span class="checkbox__label">{{ getTranslation('active') }}?</span>
        </label>
      </div>
    </modal>
  </div>
</template>

<script>
import attestationMixin from "./mixins/attestationMixin";
import required from "vuelidate/lib/validators/required";

export default {
  name: "Index",
  mixins: [attestationMixin],
  data() {
    return {
      edit: false,
      showModal: false,
      positionAttestation: false,
      showOptions: false,
      filterSettings: {
        visible: true,
        loadSelects: false
      },
      formOptions: {
        statuses: [],
        resources: [],
        registerCategories: [],
        postScopes: [],
      },
      items: [],
      filterForm: {
        page: this.$route.query.page || 1,
        status: [],
        postScope: [],
        registerCategoryId: '',
        typeIds: [this.RESOURCE_POST_ID, this.RESOURCE_POSITION_ATTESTATION_ID]
      },
      pagination: {
        total: '',
        lastPage: '',
        currentPage: ''
      },
      form: {
        id: null,
        title: '',
        titleKy: '',
        postScope: '',
        status: true,
        resourceId: '',
        resourceIds: [],
        type: {id: ''},
        typeId: this.RESOURCE_POST_ID
      }
    }
  },
  created() {

    let actions = [];

    if (this.hasPermission('api.attestation.resource.create')) {
      actions.push({
        label: this.getTranslation('add'),
        action: this.addResource,
        icon: {
          icon: '#icon__square-add'
        }
      });

      actions.push({
        label: this.getTranslation('addPositionAttestation'),
        action: this.addResourcePositionAttestation,
        icon: {
          icon: '#icon__square-add'
        }
      });
    }

    this.setHeadings({
      title: this.getTranslation('attestation'),
      actions: actions
    });


    this.fetchFormOptions().then(() => {
      this.showOptions = true;
    });

    this.fetchItems();
  },

  watch: {
    'filterForm.status'() {
      this.fetchItems();
    },
    'filterForm.resourceId'() {
      this.fetchItems();
    },
    'filterForm.postScope'() {
      this.fetchItems();
    },
  },

  methods: {


    saveResource() {

      if (this.form.hasOwnProperty('resource'))
        delete this.form.resource;

      if (this.positionAttestation)
        this.form.typeId = this.RESOURCE_POSITION_ATTESTATION_ID;
      else
        this.form.typeId = this.RESOURCE_POST_ID;

      this.form.resourceIds = [this.form.resourceId];

      this.$v.form.$touch();

      if (this.$v.form.$invalid)
        return this.snotifyError('wrongFormMsg');

      let method = 'post';
      let url = this.$config.urls.attestation.fetchResources.url;

      if (this.form.id) {
        method = 'put';
        url = this.$config.urls.attestation.fetchResource.url.replace(':id', this.form.id);
      }

      return this.axios({
        method: method,
        url: url,
        data: this.form
      }).then(() => {
        if (method === 'post')
          this.snotifySuccess('saveSuccessMsg');
        else
          this.snotifySuccess('updateSuccessMsg');

        this.fetchItems();

      }).then(() => {
        this.resetModal();
      }).catch(() => {
      });


    },


    fetchItems() {

      let params = this.cleanObject({...this.filterForm});

      params.typeIds = [this.RESOURCE_POST_ID, this.RESOURCE_POSITION_ATTESTATION_ID];

      return this.axios.get(this.$config.urls.attestation.fetchResources.url, {params: params})
          .then(response => {
            this.items = response.data.data.items;
            this.pagination.currentPage = response.data.data.activePage;
            this.filterForm.page = response.data.data.activePage;
            this.pagination.total = response.data.data.totalItemsCount;
            this.pagination.lastPage = response.data.data.pages;
          }).catch(() => {
          });
    },


    resetModal() {
      this.showModal = false;
      this.positionAttestation = false;
      this.edit = false;
      this.$v.$reset();
      this.form = {
        id: null,
        title: '',
        titleKy: '',
        postScope: '',
        status: true,
        resourceId: '',
        resourceIds: [],
        type: {id: ''},
        typeId: this.RESOURCE_POST_ID
      };
    },

    addResourcePositionAttestation() {
      this.addResource(true);
    },
    addResource(positionAttestation = false) {
      this.edit = false;
      this.positionAttestation = positionAttestation;
      this.showModal = true;
    },

    editResource(item, positionAttestation = false) {

      this.form.typeId = item.type.id;
      this.form.id = item.id;
      this.form.title = item.title;
      this.form.type = item.type;
      this.form.status = item.status;
      this.form.titleKy = item.titleKy;
      this.form.postScope = item.postScope;
      this.form.resourceId = item.resourceId;

      if (this.form.typeId === this.RESOURCE_POSITION_ATTESTATION_ID)
        positionAttestation = true;

      this.positionAttestation = positionAttestation;
      this.showModal = true;
      this.edit = true;
    },

    resetFilter() {
      this.filterForm = {
        page: 1,
      };
      this.fetchItems();
    },

    fetchFormOptions() {
      return this.axios.get(this.$config.urls.nrk.formOptions.url, {params: {typeId: this.RESOURCE_POSITION_ATTESTATION_ID}})
          .then(response => {
            this.formOptions.statuses = this.objectToArray(response.data.data.statuses, true);
            this.formOptions.resources = this.objectToArray(response.data.data.registerPosts, true, true);
            this.formOptions.postScopes = this.objectToArray(response.data.data.postScopes, true, true);
            this.formOptions.registerCategories = response.data.data.registerCategories;
          }).catch(() => {
          });
    },
  },
  validations: {
    form: {
      title: {
        required
      },
      resourceId: {
        required
      },
      resourceIds: {
        required
      },
      titleKy: {
        required
      },
      typeId: {
        required
      }
    }
  }
}
</script>

<style scoped>
.page-layout__filter {
  -ms-flex-negative: 0;
  flex-shrink: 0;
  width: 500px;
}
</style>
